import { createSelector } from '@reduxjs/toolkit';

export const getSearchNews = ()=> {
    return createSelector(
        (state) => state.search_result_news,
        (state) => state
    )
}